import React from 'react';
import Loading from '../widgets/Loading';

type Props = {
  children: React.ReactNode;
  enabled: boolean;
}

const ProgressOverlay = ({ children, enabled }: Props) => {
  if (enabled) {
    return <Loading />;
  }
  return <>{children}</>;
}

export default ProgressOverlay;
